import { useNuxtApp } from '#app'

export default defineNuxtRouteMiddleware(() => {
    // $bus may not be provided yet during the initial navigation / app init; the
    // modal-hide is non-critical, so skip rather than throw a (caught) error
    // that flashes the 500 page before the route resolves.
    useNuxtApp().$bus?.$emit('hideModalImmediately')
})
